import { styled } from '@mui/material';
import React, { useCallback } from 'react';
import Image from '~/components/Image';
import { getReportImage } from '~/scripts/getReportImage';

const StyledImage = styled(Image)`
  object-fit: contain;
  overflow: hidden;
`;
interface ReportImageProps
  extends React.ComponentPropsWithoutRef<typeof Image> {
  uuid: string;
  border?: boolean;
}

export const ReportImage = ({
  uuid,
  border,
  sx,
  ...rest
}: ReportImageProps) => {
  const onError = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      e.currentTarget.src = getReportImage('0');
    },
    []
  );
  return (
    <StyledImage
      src={getReportImage(uuid)}
      loading="lazy"
      {...rest}
      onError={onError}
      sx={{
        ...sx,
        border: border ? '1px solid #e0e0e0' : 'none',
        borderRadius: border ? '4px' : undefined,
      }}
    />
  );
};
